import uuid from 'uuid';
import database from '../firebase/firebase';


// ADD_Label
export const addLabel = (label) => ({
    type: 'ADD_LABEL',
    label
});

export const startAddLabel = (labelData = {}) => {
    return (dispatch, getState) => {
        const uid = getState().auth.uid
        const {
            label = '',
            type = '',
            alias = '',
            note = ''
        } = labelData;

        const newLabel = { label, type, alias, note };
        console.log('action/labels: ', newLabel)
        return database.ref(`users/${uid}/labels`).push(newLabel).then((ref) => {
            dispatch(addLabel({
                id: ref.key,
                ...newLabel
            }));
        });
    };
};


// REMOVE_Label
export const removeLabel = ({ id } = {}) => ({
    type: 'REMOVE_LABEL',
    id
});


// EDIT_Label
export const editLabel = (id, updates) => ({
    type: 'EDIT_LABEL',
    id,
    updates
});



// SET_LabelS
export const setLabels = ((labels) => ({
    type: 'SET_LABELS',
    labels
}))


const findNewLabels = (snapshot, labelList) => {
    const labels = []
    let newLabels = labelList
    snapshot.forEach((child) => {
        //console.log('child: ', child.val().label.toLowerCase())

        if (labelList && labelList.indexOf(child.val().label.toLowerCase()) === -1) {
            // labels.push({
            //     id: child.key,
            //     ...child.val()
            // })
            // console.log('new label found: ', child.val().label)
        } else {
            // child found remove from array list here

            //array.filter(function (value, index, arr) { return value > 5; });
            //const labelMatch = !label ? true : expense.label ? expense.label.toLowerCase() === label.toLowerCase() : false
            newLabels = newLabels.filter((label) => {
                // console.log('label toLowerCase: ', label.toLowerCase())
                // console.log('child.val().label.toLowerCase(): ', child.val().label.toLowerCase())
                const labelMatch = !label ? true : label ? label.toLowerCase() !== child.val().label.toLowerCase() : false
                return labelMatch


            })

        }


    })

    return newLabels;
}


const parseResultsToLabels = (snapshot) => {
    const labels = []
    snapshot.forEach((child) => {
        //console.log('child: ', child.val().label)
        labels.push({
            id: child.key,
            ...child.val()
        })

    })

    return labels;
}


// db.ref().update({
//     stressLevel: 9,
//     'job/company': 'Amazon',
//     'location/city': 'Seattle',
//     'location/state': 'Washington'
// })

//startEditLabel
export const startEditLabel = ((id, updates) => {
    return (dispatch, getState) => {
        const uid = getState().auth.uid

        return database.ref(`users/${uid}/labels/${id}`).update({
            ...updates
        })
            .then(() => {
                dispatch(editLabel(id, updates))
            })
    }
})

// course solution
export const startRemoveLabel = ({ id } = {}) => {
    console.log('startRemovelabel: ' + id)

    return (dispatch, getState) => {
        console.log("startRemoveBefore auth")
        const uid = getState().auth.uid
        return database.ref(`users/${uid}/labels/${id}`).remove().then(() => {
            console.log('dbRemove: startRemovelabel: ' + id)
            dispatch(removeLabel({ id }));
        }).catch((e) => {
            console.log('Remove Error: ', e)
        });
    };
    console.log('startRemovelabelFooter: ' + id)
};

//my solution - worked
// export const startRemoveLabel = (({ id }) => {
//   return (dispatch) => {
//     return database.ref(`Labels/${id}`).remove()
//       .then(() => {
//         dispatch(removeLabel({ id }));
//       }).catch((e) => {
//         console.log('Fetch Error: ', e)
//       })

//   }

// })


export const startSetGlobalLabels = (() => {
    return (dispatch, getState) => {
        const uid = getState().auth.uid
        return database.ref(`global/labels`)
            .once('value')
            .then((snapshot) => {
                console.log('snapShot: ', snapshot)
                const labels = parseResultsToLabels(snapshot)
                dispatch(setLabels(labels));
            }).catch((e) => {
                console.log('Fetch Error: ', e)
            })

    }

})



export const startImportLabels = ((newLabelList) => {
    return (dispatch, getState) => {
        const uid = getState().auth.uid
        return database.ref(`users/${uid}/labels`)
            .once('value')
            .then((snapshot) => {
                const labels = findNewLabels(snapshot, newLabelList)
                //console.log("New Imported Labels: ", labels)


                //
                labels.map((label) => {
                    //label obj
                    const newLabel = {
                        label: label,
                        type: '',
                        alias: '',
                        note: ''
                    }
                    dispatch(startAddLabel(newLabel))
                })
                //= (label = {}) => {)
                // })

                //dispatch(setLabels(labels));

            }).catch((e) => {
                console.log('Fetch Error: ', e)
            })

    }

})




export const startSetLabels = (() => {
    return (dispatch, getState) => {
        const uid = getState().auth.uid
        return database.ref(`users/${uid}/labels`)
            .once('value')
            .then((snapshot) => {
                const labels = parseResultsToLabels(snapshot)
                dispatch(setLabels(labels));
            }).catch((e) => {
                console.log('Fetch Error: ', e)
            })

    }

})





// export const startAddLabel = (LabelData = {}) => {
//   return (dispatch) => {
//     const {
//       description = '',
//       note = '',
//       amount = 0,
//       createdAt = 0
//     } = LabelData;
//     const Label = { description, note, amount, createdAt };

//     return database.ref('Labels').push(Label).then((ref) => {
//       dispatch(addLabel({
//         id: ref.key,
//         ...Label
//       }));
//     });
//   };
// };




// WEBPACK FOOTER //
// ./src/actions/labels.js